export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";